import React, {PureComponent} from 'react'
import PropTypes from 'prop-types'

export default class ProgressBar extends PureComponent {
    render() {
        const {
            value,
            description,
            secondaryValue,
            color,
        } = this.props
        return (
            <div className="progress-wrapper">
                <div className="progress">
                    <div className={"progress-bar progress-bar-" + color}
                         style={{width: Math.round(value * 1000) / 10 + '%'}}></div>
                    <div className={"progress-value progress-bar-value-" + color}>{Math.round(value * 1000) / 10} %
                        / {description}</div>
                </div>
                <div className="progress-value-secondary">{Math.round(secondaryValue * 1000) / 10} %</div>
            </div>
        )
    }
}

ProgressBar.propTypes = {
    value: PropTypes.number,
    dangerouslySetInnerHTML: PropTypes.shape({__html: PropTypes.string})
}
